var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeoffIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1001_2423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.02 21.5538C18.9998 23.1011 16.5399 23.9583 14 24C5.72727 24 1 14.5 1 14.5C2.47005 11.7473 4.50898 9.34224 6.98 7.44628M11.5182 5.28503C12.3317 5.0937 13.1645 4.99806 14 5.00003C22.2727 5.00003 27 14.5 27 14.5C26.2826 15.8485 25.4271 17.1181 24.4473 18.2881M16.5055 17.0175C16.1809 17.3675 15.7894 17.6483 15.3545 17.843C14.9196 18.0377 14.4502 18.1424 13.9741 18.1508C13.4981 18.1593 13.0252 18.0713 12.5837 17.8921C12.1422 17.7129 11.7412 17.4462 11.4045 17.1079C11.0679 16.7697 10.8025 16.3667 10.6241 15.9231C10.4458 15.4795 10.3583 15.0044 10.3667 14.526C10.3751 14.0477 10.4793 13.576 10.673 13.139C10.8668 12.702 11.1462 12.3087 11.4945 11.9825",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1L27 27",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1001_2423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeoffIcon);
export default __webpack_public_path__ + "static/media/eyeoffIcon.75f0b40c9ea260f193b67a58991ef480.svg";
export { ForwardRef as ReactComponent };